"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function ArrowRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    width: "7",
    height: "14",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 16"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(-1 0 0 1 27 -16)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.6",
    d: "M26.4 16.8L19.2 24l7.2 7.2"
  }))));
}
var _default = exports["default"] = ArrowRight;
//# sourceMappingURL=ArrowRight.js.map